<template>
  <div class="page page-references">
    <h1 class="font-black text-size-40 fg-white">References</h1>
    <div class="popup">
      <swiper
        v-if="references.length > 0"
        :direction="'vertical'"
        :slides-per-view="'auto'"
        :free-mode="true"
        :loop="false"
        :scrollbar="{ draggable: true }"
        :mousewheel="true"
      >
        <swiper-slide></swiper-slide>
        <swiper-slide>
          <ul v-if="references">
            <li
              v-for="(item, index) in references"
              :key="index"
              v-html="`${index + 1}. ${item}`"
            ></li>
          </ul>
        </swiper-slide>
        <swiper-slide></swiper-slide>
      </swiper>

      <div class="close" @click="dismiss"></div>
    </div>
  </div>
</template>

<script>
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Scrollbar } from 'swiper';
import 'swiper/swiper-bundle.css';
SwiperCore.use([Scrollbar]);

export default {
  name: 'PopupReferences',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiper: null,
      references: [],
    }
  },
  methods: {
    init() {
      this.references = this.$store.getters.references;
      if (this.swiper) {
        setTimeout(() => this.swiper.update(), 500);
      }
    },
    dismiss() {
      this.$emit('dismiss');
    }
  },
  mounted() {
    this.init();
  },
}
</script>
